import { action } from 'easy-peasy';
import { IActionSetAvailableClients } from '../types';

const setAvailableClients: IActionSetAvailableClients = action((state, payload) => {
  state.availableClients = payload;
});

export default setAvailableClients;
